import { render, staticRenderFns } from "./InventoryRequestList.vue?vue&type=template&id=e80af5c4&"
import script from "./InventoryRequestList.vue?vue&type=script&lang=js&"
export * from "./InventoryRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports